import ClassNames from "classnames";
import { FunctionComponent } from "react";
import styles from "../stylesheets/components/partner-logo.module.css";
import { PartnerLogoSize, TranslatedPartnerLogo } from "../types/index.js";
import LazyImage from "./LazyImage.js";

interface Props {
  partnerLogo: TranslatedPartnerLogo;
  size: PartnerLogoSize;
  className?: string;
}

const PartnerLogo: FunctionComponent<Props> = ({
  partnerLogo,
  size,
  className,
}) => {
  const {
    translation: { url: logoURL, width, height },
    partner: {
      translation: { origin, url, name },
    },
  } = partnerLogo;

  const href = origin + url;

  return (
    <a
      href={href}
      target="_blank"
      rel="noopener"
      className={ClassNames(
        styles.PartnerLogo,
        { [styles[`PartnerLogo--small`]]: size === "small" },
        className,
      )}
    >
      <LazyImage src={logoURL} alt={name} width={width} height={height} />
    </a>
  );
};

export default PartnerLogo;
